import React from 'react';
import xss from 'xss';
import { ViewMode } from '../../constants';

interface FormsProps {
  view: ViewMode;
  title?: string;
  description?: string;
  backgroundColor?: string;
  cardColor?: string;
  buttonColor?: string;
  buttonTextColor?: string;
  buttonLabel?: string;
  buttonFontSize?: number;
  buttonFontFamily?: string;
  fields?: { name: string; placeholder: string; type?: string; required?: boolean }[];
  footerBrand?: string;
  footerLinks?: { label: string; href: string }[];
}

export function Forms({
  view,
  title = 'Join Us!',
  description = 'We would love for you to consider joining our family. Our goal is to create a better way to communicate and learn from our customers and fans so that we can ultimately better serve your needs. Apply Now!',
  backgroundColor = '#b28d7b',
  cardColor = '#f5f1ed',
  buttonColor = '#5b2323',
  buttonTextColor = 'white',
  buttonLabel = 'Submit Application',
  buttonFontSize,
  buttonFontFamily,
  fields = [
    { name: 'firstName', placeholder: 'First Name*', required: true },
    { name: 'lastName', placeholder: 'Last Name*', required: true },
    { name: 'email', placeholder: 'Email Address*', type: 'email', required: true },
    { name: 'instagram', placeholder: 'Instagram*', required: true },
  ],
  footerBrand = 'Aspire',
  footerLinks = [
    { label: 'Terms of Service', href: '#' },
    { label: 'Privacy Policy', href: '#' },
  ],
}: FormsProps) {
  const isDesktop = view === ViewMode.DESKTOP;

  const buttonStyle = {
    background: buttonColor,
    color: buttonTextColor,
    fontSize: buttonFontSize,
    fontFamily: buttonFontFamily,
  };

  return (
    <div
      className={`w-full min-h-screen flex items-center justify-center${isDesktop ? ' py-16' : ''}`}
      style={{ background: backgroundColor }}
    >
      <form
        className={
          isDesktop
            ? 'rounded-2xl shadow-lg max-w-md w-full p-8 flex flex-col gap-4'
            : 'rounded-xl shadow-lg max-w-xs w-full p-4 flex flex-col gap-3'
        }
        style={{ background: cardColor }}
      >
        <div className={isDesktop ? 'text-xl font-semibold text-center mb-2' : 'text-lg font-semibold text-center mb-1'}>{title}</div>
        <div
          className={isDesktop ? 'text-base text-center mb-6 text-gray-800' : 'text-sm text-center mb-4 text-gray-800'}
          dangerouslySetInnerHTML={{ __html: xss(description) }}
        />
        {fields.map((field) => (
          <input
            key={field.name}
            className={
              isDesktop
                ? 'rounded-lg border border-gray-300 px-4 py-3 text-base focus:outline-none focus:border-gray-400 transition-colors'
                : 'rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:border-gray-400 transition-colors'
            }
            placeholder={field.placeholder}
            type={field.type || 'text'}
            required={field.required}
            name={field.name}
          />
        ))}
        <button
          type="submit"
          className={isDesktop ? 'w-full py-3 rounded-lg text-lg font-semibold mt-2' : 'w-full py-2 rounded-lg text-base font-semibold mt-2'}
          style={buttonStyle}
        >
          {buttonLabel}
        </button>
        <div className={isDesktop ? 'flex flex-col items-center mt-4 gap-1' : 'flex flex-col items-center mt-3 gap-1'}>
          <span className="font-bold text-sm">{footerBrand}</span>
          <div className="flex gap-4 text-xs">
            {footerLinks.map((link) => (
              <a key={link.label} href={link.href} className="underline hover:text-[#5b2323]">
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </form>
    </div>
  );
}
